<section>
  <div class="sx-dialog__scroll-area">
    <header class="sx-dialog__content">
      <h2 class="sx-dialog__heading h3" *ngIf="meteringType === meteringTypeEnum.Hot || meteringType === meteringTypeEnum.Cold">
        {{(meteringType === meteringTypeEnum.Hot ? 'metering.filter.form.title_hot' : 'metering.filter.form.title_cold') | translate}}
      </h2>
      <h2 class="sx-dialog__heading h3" *ngIf="meteringType === meteringTypeEnum.HotLogical || meteringType === meteringTypeEnum.ColdLogical">
        {{(meteringType === meteringTypeEnum.HotLogical ? 'metering.filter.form.title_hot_logical' : 'metering.filter.form.title_cold_logical') | translate}}
      </h2>
    </header>

    <div class="sx-dialog__content sx-dialog__content--search">
      <!-- Search Form -->
           <div>
             <mat-form-field class="sxh-full-width" appearance="outline">
               <input matInput [(ngModel)]="searchFilter" id="field_search_meteringpoints" (keyup)='keyUp.next($event)' placeholder="{{'metering.group-dialog.search' | translate}}" >
               <svg class="sx-filter-pane__search-icon">
                <use xlink:href="#baseline-search-24px" href="#baseline-search-24px" />
              </svg>
             </mat-form-field>
           </div> 
    </div>

    <div class="sx-dialog__content sxl-horizontal-stack sxh-text-light sx-dialog__content--filter-type">
      <mat-radio-group name="filterType" [value]="isSearchAddresses" (change)="onFilterTypeChange($event)">
        <mat-radio-button [value]="false">{{'metering.filter.form.name' | translate}}</mat-radio-button>
        <mat-radio-button [value]="true">{{'metering.filter.form.adress' | translate}}</mat-radio-button>
      </mat-radio-group>
    </div>

    <div class="sx-dialog__sectioner sxl-row-space-between" [hidden]="isSearchAddresses || meteringType === meteringTypeEnum.HotLogical || meteringType === meteringTypeEnum.ColdLogical">
      <span>{{'metering.filter.form.groups' | translate}}</span>
      <span>{{'metering.filter.form.count' | translate}}</span>
    </div>

    <div class="sx-dialog__content" [hidden]="isSearchAddresses || meteringType === meteringTypeEnum.HotLogical || meteringType === meteringTypeEnum.ColdLogical">
      <div class="sx-dialog__option-row" [hidden]="!virtualGroupActivated">
          <mat-radio-button [checked]="selectedVirtual" (click)="onVirtualFilterSelected()">
            {{'metering.filter.form.virtual-group' | translate}}
          </mat-radio-button>
          <div class="sx-dialog__option-fragment-end">{{virtualGroupMeteringPointIds.length}}</div>
      </div>

      <div class="sx-dialog__option-row">
        <mat-radio-button [checked]="isAllMeteringPointsChecked" (click)="onAllMeteringPointsSelected()">
          {{'metering.filter.form.all' | translate}}
        </mat-radio-button>
        <div class="sx-dialog__option-fragment-end">{{meteringPoints.length}}</div>
      </div>

      <div [hidden]="meteringPointGroupsView.length === 0">
        <div class="sx-dialog__option-row" *ngFor="let meteringPointGroup of meteringPointGroupsView">
          <mat-radio-button [checked]="selectedMeteringPoints.length === 0 && meteringPointGroup.selected" [value]="meteringPointGroup" (change)="onSelectMeteringGroup($event)">
            {{meteringPointGroup.name}}
          </mat-radio-button>
          <div class="sx-dialog__option-fragment-end">
            {{meteringPointGroup.meteringPoints ? meteringPointGroup.meteringPoints.length : ''}}
          </div>
        </div>
      </div>
    </div>

    <div class="sx-dialog__sectioner sxl-space-between" [hidden]="meteringPointsView.length === 0">
      <span>{{'metering.filter.form.metering_points' | translate}}</span>
    </div>

    <div class="sx-dialog__content" [hidden]="meteringPointsView.length === 0">
      <div class="sx-dialog__option-row" *ngFor="let meteringPoint of meteringPointsView">
        <ng-container *ngIf="!isLogical">
          <mat-checkbox [checked]="meteringPoint.selected && isShowSelectedMeteringPoints" (change)="onMeteringPointSelected($event, meteringPoint)">
            <span class="sxh-text-mp-capitalize">{{isSearchAddresses ? meteringPoint.addressLabel : meteringPoint.name}}</span>
            <span class="sxh-text-mp-id">({{meteringPoint.id}})</span>
            <span class="sxh-text-mp-id" *ngIf="meteringPoint.type ==='LOG'">{{'metering.filter.form.logical' | translate}}</span> 
          </mat-checkbox>        
        </ng-container>
        <ng-container *ngIf="isLogical">
          <mat-radio-button [checked]="meteringPoint.selected" [value]="meteringPoint" (change)="onLogicalMeteringPointSelected($event)">
            <span class="sxh-text-mp-capitalize">{{isSearchAddresses ? meteringPoint.addressLabel : meteringPoint.name}}</span>
            <span class="sxh-text-mp-id">({{meteringPoint.id}})</span>
            <span class="sxh-text-mp-id" *ngIf="meteringPoint.type ==='LOG'">{{'metering.filter.form.logical' | translate}}</span> 
          </mat-radio-button>
        </ng-container>
      </div>
    </div>
  </div>

  <div class="sxh-button-footer sxl-align-right sxl-horizontal-stack-small">
    <button class="sx-button sx-button--white" id="form_cancel_btn" mat-button (click)="onCancel()">
      {{'core.button.cancel' | translate}}
    </button>
    <button class="sx-button sx-button--magenta" id="form_ok_btn" mat-button [disabled]="selectedMeteringPoints.length === 0 && !(!!selectedMeteringPointGroup)"
      (click)="onSave()">
      {{'core.button.save_and_close' | translate}}</button>
  </div>
</section>
